/// <amd-module name='SuiteCommerce.ItemRecSys.Debug.Mocks'/>
define("SuiteCommerce.ItemRecSys.Debug.Mocks", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getRecSysResponseMock = getRecSysResponseMock;
    function getRecSysResponseMock(widgetSettings) {
        var dfd = jQuery.Deferred();
        if (widgetSettings.numberOfItems < 1) {
            // Reject after a random interval
            setTimeout(function () {
                dfd.reject('invalid - no items');
            }, 500);
        }
        else {
            setTimeout(function () {
                dfd.resolve({
                    result: [15, 8, 7, 6, 5, 120047, 100057, 100062, 100050],
                    UUID: "7ad547bc-2c05-4b7d-80ad-817a2ed1cb7b",
                    info: {
                        "trainInstance": {
                            "key": 4,
                            "trainDefinitionId": 4,
                            "active": true,
                            "status": "OK",
                            "trainingStart": "2020-04-20 10:53:07",
                            "trainingEnd": "2020-04-20 10:53:08",
                            "trainParams": "{\r\n  \"alpha\": 150,\r\n  \"lambda\": 0.01,\r\n  \"iterations\": 20,\r\n  \"rank\": 200,\r\n  \"maxDataAgeDays\": 3650,\r\n  \"interactionThreshold\": 0,\r\n  \"shopperPredictionCount\": 50,\r\n  \"itemPredictionCount\": 50,\r\n  \"threads\": 0\r\n}",
                            "misc": "{}",
                            "evalMetrics": "{\"AUC@0.10\":\"0.00000\",\"CatalogCoverage@10\":\"1.00000\",\"TrainSparsity\":\"0.65000\",\"Items\":5,\"TrainInteractions\":7,\"Precision@10\":\"1.00000\",\"Shoppers\":4}",
                            "created": "2020-04-20 10:53:07",
                            "modified": "2020-04-20 10:53:07"
                        },
                        "trainDefinition": {
                            "key": 4,
                            "compId": "3619616",
                            "siteId": 2,
                            "algorithm": "AlsMfFactory",
                            "params": "{\r\n  \"alpha\": 150,\r\n  \"lambda\": 0.01,\r\n  \"iterations\": 20,\r\n  \"rank\": 200,\r\n  \"maxDataAgeDays\": 3650,\r\n  \"interactionThreshold\": 0,\r\n  \"shopperPredictionCount\": 50,\r\n  \"itemPredictionCount\": 50,\r\n  \"threads\": 0\r\n}",
                            "trainIntervalHours": 24,
                            "active": true,
                            "misc": "{}",
                            "name": "Test",
                            "created": "2020-04-20 10:09:08",
                            "modified": "2020-04-20 10:09:08"
                        },
                        "isFallback": false,
                        "modelDefinition": {
                            "key": 5,
                            "compId": "3619616",
                            "siteId": 2,
                            "trainDefinitionId": 4,
                            "useCase": "SHOPPER_TRANSACTIONS_HISTORY",
                            "serveParams": "{}",
                            "misc": "{}",
                            "priority": 99,
                            "active": true,
                            "name": "adf",
                            "created": "2020-04-20 10:27:56",
                            "modified": "2020-04-20 10:27:56"
                        }
                    }
                });
            }, 500);
        }
        return dfd.promise();
    }
});
